export const Hamburger = () => (
  <span className="hamburger">
    <a className="main-nav-toggle">
      <i>Menu</i>
    </a>
  </span>
)
